import React from 'react'
import Link from 'gatsby-link'

import './header.styl'

const NaviModal = (props) => (
  <nav>
        <Link to="/" onClick={props.handleClick} >Inicio</Link>
        <Link to="/portfolio" onClick={props.handleClick} >Portafolio</Link>
        <Link to="/about/" onClick={props.handleClick} >Nosotros</Link>
        <Link to="/services/" onClick={props.handleClick} >Servicios</Link>
        <Link to="/careers/" onClick={props.handleClick}>Trabajo</Link>
        <Link to="/blog/" onClick={props.handleClick}>Blog</Link>
        <Link to="/contact/" onClick={props.handleClick}>Contacto</Link>
  </nav> 
)

export default NaviModal



// WEBPACK FOOTER //
// ./src/components/nav-modal.js